/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Nombre d\'accès',
    BLACK_FRIDAY_COMISSION_TITLE: 'Commissions black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Commissions du vendredi noir {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Commissions du vendredi noir {0}',
    COMISSION_DESCRIPTION: 'Total du mois actuel :',
    COMISSION_LAST_MONTH: 'Homologue',
    COMISSION_LAST_TEN: '{0} derniers jours',
    COMISSION_TITLE: 'Commissions des {0} derniers jours :',
    COMMISSION: 'Commission',
    COMMISSION_COLUMN: 'Commission (€)',
    DAILY: 'Du quotidien',
    DATE: 'Date',
    FEMALE: 'Femme',
    FIFTY_DAYS: '50 jours',
    GENDER: 'Sexe',
    HITS: 'Accès des {0} derniers jours :',
    HITS_DESCRIPTION: 'Accès',
    HOMOLOGOUS: 'Homologue',
    HOMOLOGOUS_LAST_YEAR: 'Dernière année',
    MALE: 'Homme',
    NAME: 'Nom',
    NEW_CUSTOMERS: 'Nouveaux comptes clients {0} jours:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Nouveaux comptes clients Prozis anniversaire',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Nouveaux comptes en attente de commande {0} jours:',
    NO_SALES: 'Aucune vente',
    ORDER_PENDING_CUSTOMERS: 'Compte en attente de commande',
    ORDERED_CUSTOMERS: 'Nouveau compte client',
    ORDERS: 'Commandes des {0} derniers jours :',
    ORDERS_DESCRIPTION: 'Commandes payées des 6 derniers mois',
    ORDERS_DETAIL_DESCRIPTION:
      'Commandes en attente de paiement des {0} derniers jours :',
    ORDERS_PAY: 'Commandes payées',
    ORDERS_PENDING: 'Commandes en attente',
    PERCENTAGE: 'Pourcentage',
    PRODUCT_CATEGORY: 'Catégorie',
    PRODUCT_COLUMN: 'Produit',
    QT_COLUMN: 'Quantité',
    QUANTITY: 'Quantité',
    SALES: 'Ventes',
    SALES_DESCRIPTION: 'Mois actuel',
    SALES_PRODUCT: 'Ventes par catégories de produits',
    TEN_DAYS: '10 jours',
    THIRTEEN_DAYS: '30 jours',
    TOP_COMMISSION_TITLE: 'Produits qui ont généré le plus de commissions',
    TOP_DESCRIPTION: 'Mois actuel',
    TOP_GENDER_DESCRIPTION: 'Derniers {0} jours',
    TOP_GENDER_TITLE: 'Produits les plus vendus par sexe',
    TOP_TITLE: 'Produits les plus vendus',
    TWENTY_DAYS: '20 jours',
    UPDATED_AT: 'Mis à jour le {0}',
    VALUE: 'Montant'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Données manquantes',
    EMPTY_TITLE: 'Aucune donnée'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
